import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Typography, Container, Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { auth } from '../services/api';
import { set } from 'date-fns';

export const Login: React.FC = () => {
    document.title = "Duitleh - Login";
    const navigate = useNavigate();
    const { login } = useAuth();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        username: '',
        password: '',
    });
    const [error, setError] = useState('');

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            setLoading(true);
            await login(formData.username, formData.password);
            navigate('/dashboard');
        } catch (err: any) {
            setError(err.response?.data?.message || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <img src="/duitleh.png" alt="Duitleh Logo" style={{ width: 130, height: 'auto', marginBottom: 16 }} />
                <Typography component="h1" variant="h5" fontWeight={'bold'}>
                    Login
                </Typography>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label="Username"
                        name="username"
                        autoComplete="username"
                        autoFocus
                        value={formData.username}
                        onChange={handleChange}
                        variant='outlined'
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '13px',  // 设置圆角
                            }
                        }}
                        error={!!error}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={formData.password}
                        onChange={handleChange}
                        variant='outlined'
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '13px',  // 设置圆角
                            }
                        }}
                        error={!!error}
                        helperText={error}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        name="loginBtn"
                        sx={{
                            mt: 5,
                            mb: 1   ,
                            borderRadius: '13px',
                            py: 1.2 ,
                            textTransform: 'none',
                        }}  
                        loading={loading}
                    >
                        Log In
                    </Button>
                    <Button
                        fullWidth
                        variant="text"
                        onClick={() => navigate('/register')}
                        sx={{

                            textTransform: 'none', 
                            mb: 0, 
                            py: 0,
                            mt: 1,
                        }}
                    >
                        Don't have an account? Sign Up
                    </Button>
                    <Button
                        fullWidth
                        variant="text"
                        onClick={() => navigate('/forgot-password')}
                        sx={{

                            textTransform: 'none',
                            mx: 0,
                            py: 0,
                        }}
                    >
                        Forgot Password?
                    </Button>
                </Box>
            </Box>
        </Container>
    );
};
function useRef(arg0: null) {
    throw new Error('Function not implemented.');
}

